import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

import { TranslateHttpLoader } from './translateHttpLoader';

export function createTranslateLoader() {
    return new TranslateHttpLoader(inject(HttpClient), './assets/i18n/', '.json');
}
